import script from "./WikiComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./WikiComponent.vue?vue&type=script&setup=true&lang=js"

import "./WikiComponent.vue?vue&type=style&index=0&id=e871f688&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e871f688"]])

export default __exports__